import React from 'react';
import { useLocation } from 'react-router-dom';
import PreHeader from './PreHeader';
import Header from './Header';
import HomeHeader from './HomeHeader';

const SiteHeader = () => {
  const location = useLocation();
  const isHome = location.pathname === '/';

  return (
    <header className="sticky top-0 z-50 w-full shadow-md">
      <PreHeader />
      {isHome ? <HomeHeader /> : <Header />}
    </header>
  );
};

export default SiteHeader;
